import styled from "styled-components";
import { Link } from "react-router-dom";
import colors from "frontend/src/constants/colors";

export const MutedFooterLink = styled(Link)`
  color: ${colors.textGray};

  &:hover {
    color: ${colors.secondary};
  }
`;
